import { render, staticRenderFns } from "./StaffShareBox.vue?vue&type=template&id=02b034fe&scoped=true"
import script from "./StaffShareBox.vue?vue&type=script&lang=js"
export * from "./StaffShareBox.vue?vue&type=script&lang=js"
import style0 from "./StaffShareBox.vue?vue&type=style&index=0&id=02b034fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b034fe",
  null
  
)

export default component.exports